import { SET_SELECTED_SEARCH_KEY } from "./actionTypes"

export const setSelectedSearchKey = (selectedSearchKey) => {
	return {
		type: SET_SELECTED_SEARCH_KEY,
		payload: selectedSearchKey
	};
};


// WEBPACK FOOTER //
// ./src/actions/search.js